import { api } from "../App";
import { createNotification } from "../components/Notifications/Notifications";
import { objFilter } from "../utils/smallHelpers";

import {
  GET_CLASSBOOK_STUDY_PERIOD,
  SET_CLASSBOOK_LOADING,
  GET_CLASSBOOK_LESSON,
  GET_CLASSBOOK_CLASS,
  GET_CLASSBOOK,
  GET_CLASSBOOK_GRADE_VALUE,
  GET_LESSON_CHART,
  GET_CLASS_TOPIC,
  GET_EVENT_TOOLS,
  GET_PLANNERF_LIST,
  GET_HOMEWORKF_LIST,
  GET_PLANNER_LIST,
  GET_HOMEWORK_LIST,
  GET_ABSENCES,
  GET_ATTENDANCES,
  GET_CLASSBOOK_GRADE_TYPES,
  GET_CLASSBOOK_SUMMARY,
  GET_RECOMMENDATIONS,
  UPDATE_CLASSBOOK_GRADE,
  UPDATE_LESSON_CHART,
} from "./types";


export const getStudyPeriod = (params) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/terms?schoolyear${typeof params == 'number' ? params : params.scYear}`);
    dispatch({ type: GET_CLASSBOOK_STUDY_PERIOD, payload: data.terms });
  } catch (error) {
    console.error('Error in classbook action:', error);
    dispatch({ type: GET_CLASSBOOK_STUDY_PERIOD, payload: [] });
  }
}
export const getLesson = (params) => async (dispatch, getState) => {
  try {
    const qParams = {}
    params?.type && (qParams.type = params.type)
    const searchParams = new URLSearchParams(qParams).toString();
    const { data } = await api.get(`/lessons/${params.scYear}/${params.studyPeriod}?${searchParams}`);
    dispatch({ type: GET_CLASSBOOK_LESSON, payload: data.lessons });
  } catch (error) {
    console.error('Error in classbook action:', error);
  }
}
export const getLessonAdmissions = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/lessons`);
    dispatch({ type: GET_CLASSBOOK_LESSON, payload: data.lessons });
  } catch (error) {
    console.error('Error in classbook action:', error);
  }
}
// РЕКОМЕНДАЦИИ СПЕЦИАЛИСТОВ
export const getRecommendations = (params) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/personal_info/journal/${params.studyPeriod}/${params.lesson}/${params.class}`);
    dispatch({ type: GET_RECOMMENDATIONS, payload: data });
  } catch (error) {
    console.error('Error in classbook action:', error);
  }
}
//  Вкладка СВЕДЕНИЯ О КОЛИЧЕСТВЕ ДНЕЙ И УРОКОВ. ПРОПУЩЕННЫХ УЧАЩИМИСЯ
export const getAbsences = (trmid, gid) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/group/absence/${trmid}/${gid}`);
    dispatch({ type: GET_ABSENCES, payload: data });
  } catch (error) {
    console.error('Error in classbook action:', error);
  }
}
// ВЕДОМОСТЬ ПОСЕЩАЕМОСТИ
export const getAttendances = (trmid, gid) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/group/attendance/${trmid}/${gid}`);
    dispatch({ type: GET_ATTENDANCES, payload: data });
  } catch (error) {
    console.error('Error in classbook action:', error);
  }
}
export const getClassbookSummary = (trmid, gid, grade_type) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/group/summary/${trmid}/${gid}/${grade_type}`);
    dispatch({ type: GET_CLASSBOOK_SUMMARY, payload: data });
  } catch (error) {
    console.error('Error in classbook action:', error);
  }
}
// список из типов оценок
export const getClassbookGradeTypes = (trmid, gid) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/group/grade_type`);
    dispatch({ type: GET_CLASSBOOK_GRADE_TYPES, payload: data });
  } catch (error) {
    console.error('Error in classbook action:', error);
  }
}
export const getScClass = (params) => async (dispatch, getState) => {
  try {
    const qParams = {}
    params?.type && (qParams.type = params.type)
    const searchPaarams = new URLSearchParams(qParams).toString();
    const { data } = await api.get(`/group/${params?.studyPeriod}/${params?.lesson}?${searchPaarams}`);
    dispatch({ type: GET_CLASSBOOK_CLASS, payload: data.groups });
  } catch (error) {
    console.error('Error in classbook action:', error);
  }
}

export const getClassbook = (params) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_CLASSBOOK_LOADING, payload: true });

    const _params = { dropouts: Number(params.dropouts), type: params.type }
    const filteredParams = objFilter(_params);
    const urlParams = new URLSearchParams(filteredParams).toString();

    const { data } = await api.get(`/group_journal/${params?.studyPeriod}/${params.lesson}/${params.class}?${urlParams}`);
    dispatch({ type: GET_CLASSBOOK, payload: data });
  } catch (error) {
    console.error('Error in classbook action:', error);
    dispatch({ type: GET_CLASSBOOK, payload: { classbook: [], class_teacher_fio: '', teacher_fio: '' } });
  } finally {
    dispatch({ type: SET_CLASSBOOK_LOADING, payload: false });
  }
}

export const getGradeValue = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/grade_value`);
    dispatch({ type: GET_CLASSBOOK_GRADE_VALUE, payload: data });
  } catch (error) {
    console.error('Error in classbook action:', error);
  }
}

export const setClassbook = (params, formData) => async (dispatch, getState) => {
  try {
    const _params = { type: formData.type }
    const filteredParams = objFilter(_params);
    const urlParams = new URLSearchParams(filteredParams).toString();

    await api.put(`/upsave_journal_grade?${urlParams}`, params);
    // Обновляем только изменённую ячейку без перезагрузки всего журнала
    dispatch({
      type: UPDATE_CLASSBOOK_GRADE,
      payload: {
        mid: params.mid,
        lessonid: params.lessonid,
        lessonunixdate: params.lessonunixdate,
        grade: params.grade,
        gradecomment: params.gradecomment,
      }
    });
  } catch (error) {
    console.error('Error in classbook action:', error);
  }
}

export const getLessonChart = (params) => async (dispatch, getState) => {
  try {
    const _params = { type: params.type }
    const filteredParams = objFilter(_params);
    const urlParams = new URLSearchParams(filteredParams).toString();

    const { data } = await api.get(`/lesson_chart/${params.studyPeriod}/${params.class}/${params.lesson}?${urlParams}`);
    dispatch({ type: GET_LESSON_CHART, payload: data.lesson_chart });
  } catch (error) {
    console.error('Error in classbook action:', error);
  }
}

export const getClassTopic = (year, sheid) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/class_topic/${year}/${sheid}`);
    dispatch({ type: GET_CLASS_TOPIC, payload: data });
  } catch (error) {
    console.error('Error in classbook action:', error);
  }
}

export const getEventTools = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/eventtools`);
    dispatch({ type: GET_EVENT_TOOLS, payload: data.eventtools });
  } catch (error) {
    console.error('Error in classbook action:', error);
  }
}

export const getPlannerF = (week, sheid) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/PlannerF/file_names/${week}/${sheid}`);
    dispatch({ type: GET_PLANNERF_LIST, payload: data });
  } catch (error) {
    console.error('Error in classbook action:', error);
    dispatch({ type: GET_PLANNERF_LIST, payload: [] });
  }
}

export const addPlannerF_Plan = (data, week, sheid) => async (dispatch, getState) => {
  try {
    const fd = new FormData();
    fd.append("file", data);

    await api.post(`/PlannerF/file/${week}/${sheid}`, fd);
    createNotification('success', 'Успешно');
    await dispatch(getPlannerF(week, sheid));
  } catch (error) {
    console.error('Error in classbook action:', error);
  }
};

export const deletePlannerF_Plan = (week, sheid, name) => async (dispatch, getState) => {
  try {
    await api.delete(`/PlannerF/file/${week}/${sheid}/${name}`);
    createNotification('success', 'Успешно');
    await dispatch(getPlannerF(week, sheid));
  } catch (error) {
    console.error('Error in classbook action:', error);
  }
};

export const getHomeWorkF = (week, sheid) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/homeworkF/file_names/${week}/${sheid}`);
    dispatch({ type: GET_HOMEWORKF_LIST, payload: data });
  } catch (error) {
    console.error('Error in classbook action:', error);
    dispatch({ type: GET_HOMEWORKF_LIST, payload: [] });
  }
}

export const addHomeWorkF_Plan = (data, week, sheid) => async (dispatch, getState) => {
  try {
    const fd = new FormData();
    fd.append("file", data);

    await api.post(`/homeworkF/file/${week}/${sheid}`, fd);
    createNotification('success', 'Успешно');
    await dispatch(getHomeWorkF(week, sheid));
  } catch (error) {
    console.error('Error in classbook action:', error);
  }
};

export const deleteHomeWorkF_Plan = (week, sheid, name) => async (dispatch, getState) => {
  try {
    await api.delete(`/homeworkF/file/${week}/${sheid}/${name}`);
    createNotification('success', 'Успешно');
    await dispatch(getHomeWorkF(week, sheid));
  } catch (error) {
    console.error('Error in classbook action:', error);
  }
};

export const getPlanner = (week, sheid) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/Planner/file_names/${week}/${sheid}`);
    dispatch({ type: GET_PLANNER_LIST, payload: data });
  } catch (error) {
    console.error('Error in classbook action:', error);
    dispatch({ type: GET_PLANNER_LIST, payload: [] });
  }
}

export const addPlanner_Plan = (data, week, sheid) => async (dispatch, getState) => {
  try {
    const fd = new FormData();
    fd.append("file", data);

    await api.post(`/Planner/file/${week}/${sheid}`, fd);
    createNotification('success', 'Успешно');
    await dispatch(getPlanner(week, sheid));
  } catch (error) {
    console.error('Error in classbook action:', error);
  }
};

export const deletePlanner_Plan = (week, sheid, name) => async (dispatch, getState) => {
  try {
    await api.delete(`/Planner/file/${week}/${sheid}/${name}`);
    createNotification('success', 'Успешно');
    await dispatch(getPlanner(week, sheid));
  } catch (error) {
    console.error('Error in classbook action:', error);
  }
};

export const getHomeWork = (week, sheid) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/homework/file_names/${week}/${sheid}`);
    dispatch({ type: GET_HOMEWORK_LIST, payload: data });
  } catch (error) {
    console.error('Error in classbook action:', error);
    dispatch({ type: GET_HOMEWORK_LIST, payload: [] });
  }
}

export const addHomeWork_Plan = (data, week, sheid) => async (dispatch, getState) => {
  try {
    const fd = new FormData();
    fd.append("file", data);

    await api.post(`/homework/file/${week}/${sheid}`, fd);
    createNotification('success', 'Успешно');
    await dispatch(getHomeWork(week, sheid));
  } catch (error) {
    console.error('Error in classbook action:', error);
  }
};

export const deleteHomeWork_Plan = (week, sheid, name) => async (dispatch, getState) => {
  try {
    await api.delete(`/homework/file/${week}/${sheid}/${name}`);
    createNotification('success', 'Успешно');
    await dispatch(getHomeWork(week, sheid));
  } catch (error) {
    console.error('Error in classbook action:', error);
  }
};
////

export const setClassbookHomework = (params, formData) => async (dispatch, getState) => {
  // legacy stub — use setLessonChart instead
}

export const setLessonChart = (modalData, formData, saveData) => async (dispatch, getState) => {
  try {
    const payload = {
      sh_mod_fact_id: modalData.sh_mod_fact_id,
      hw_text: saveData.hwtext || '',
      lesson_entries: saveData.lessonEntries || [],
    };
    await api.put('/upsave_lesson_chart', payload);
    createNotification('success', 'Сохранено');
    dispatch({
      type: UPDATE_LESSON_CHART,
      payload: {
        sh_mod_fact_id: modalData.sh_mod_fact_id,
        hw_text_j: saveData.hwtext || '',
        has_topic: (saveData.lessonEntries || []).some(e => e.selectedTopics?.length > 0),
      }
    });
    await dispatch(getLessonChart(formData));
  } catch (error) {
    console.error('Error saving lesson chart:', error);
    createNotification('error', 'Ошибка сохранения');
  }
}

export const setLessonPassed = (sh_mod_fact_id, passed) => async (dispatch, getState) => {
  try {
    await api.put('/upsave_lesson_chart', { sh_mod_fact_id, passed });
    dispatch({ type: UPDATE_LESSON_CHART, payload: { sh_mod_fact_id, passed } });
  } catch (error) {
    console.error('Error saving lesson passed:', error);
  }
}